/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */



$(document).ready(function() {  
    var continuous = function () {
        $("#Annouce_first_alert").fadeToggle(600);
        $("#Annouce_second_alert").fadeToggle(600);   
    };
    $("#Annouce_second_alert").hide();
    setInterval(continuous,7000); 
});


/*

$(function(){
    //this sets an infinite timer that launches the function after
    //5 seconds, and keeps doing it every 5 seconds infinitely.
    setInterval(TogglePanels,5000);
});

function TogglePanels(){
    var $first;
    var $second;
    //check which one is visible, to fade it out first:
    if($("#Annouce_first_alert").is(":visible")){
      $first=$("#Annouce_first_alert");
      $second=$("#Annouce_second_alert");
    }else{
      $first=$("#Annouce_second_alert");
      $second=$("#Annouce_first_alert");
    }
  
   //fade out the visible panel
   $first.fadeToggle("slow",function(){
       //this is a callback function that runs when the fading is complete.
       //fade in the invisible panel
        $second.fadeToggle("slow");
   }); 
   
}
*/